import React from 'react'
import { Modal } from 'antd'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LntModalFC, LntModalProps } from './types'

export const LntModal: LntModalFC<LntModalProps> = ({ className: outerClassName, title, children, ...props }) => {
  const className: string = classNames(outerClassName, styles.lntModal)

  return (
    <Modal
      destroyOnClose={ true }
      { ...props }
      title={ <h4>{ title }</h4> }
      className={ className }
    >
      { children }
    </Modal>
  )
}

LntModal.info = Modal.info
LntModal.success = Modal.success
LntModal.error = Modal.error
LntModal.warning = Modal.warning
LntModal.confirm = Modal.confirm
